import { apiDefault } from 'src/api/config';

export default function fetchClientNeeds(personId) {
  const request = apiDefault.get(`/people/${personId}/person_conditions`);

  function onSuccess(payload) {
    return payload?.data?.data;
  }

  function onError(error) {
    return error;
  }
  return request.then(onSuccess, onError);
}
